import { useMutation } from "@tanstack/react-query";
import { OrderHistoryConfirmedApi } from "@/features/my-order/features/order-history/features/final-copy/api";
import { OrderHistoryConfirmedAmendOrderRequest } from "@/features/my-order/features/order-history/features/final-copy/types";
import useIdentity from "@/features/ui/hooks/use-identity";
import usePutOrderSheetSetUpdateStatus from "@/features/my-order/features/order-history/features/final-copy/hooks/query/usePutOrderSheetSetUpdateStatus";

const usePostOrderHistoryConfirmedAmendOrder = (orderSheetSetId: number) => {
  const identity = useIdentity();
  const buyer_id = identity?.company?.id;

  const { updateStatus } = usePutOrderSheetSetUpdateStatus(orderSheetSetId);

  const { mutate: postAmendOrder, isPending } = useMutation({
    mutationKey: ["postAmendOrder", orderSheetSetId],
    mutationFn: (params: OrderHistoryConfirmedAmendOrderRequest) =>
      OrderHistoryConfirmedApi.postAmendOrder(buyer_id!, params),
    onSuccess: () => {
      // updateStatus({
      //   order_sheet_set_ids: [orderSheetSetId],
      //   status: "MODIFICATION_REQUIRED",
      // });
    },
  });

  return {
    postAmendOrder,
    isPending,
  };
};

export default usePostOrderHistoryConfirmedAmendOrder;
